export default "__VITE_ASSET__5081b681__"